<script>
	import { convert } from "src/services/helpers";
	import { Table } from "@sveltestrap/sveltestrap";

	export let detailData;

	let {
		job: { auditTrail },
	} = detailData;

	// sort the jobs by most recent to least recent
	auditTrail = auditTrail.reverse();
</script>

<Table responsive hover>
	<thead>
		<tr>
			<th>Date & Time</th>
			<th>Description</th>
		</tr>
	</thead>
	<tbody>
		{#if detailData.job.tasks.length === 0}
			<tr>
				<td colspan="2">
					<b class="d-flex justify-content-center">
						No data for this job
					</b>
				</td>
			</tr>
		{:else}
			{#each auditTrail as { timestamp, description }, idx}
				<tr>
					<td>{convert(timestamp)}</td>
					<td>{description}</td>
				</tr>
			{/each}
		{/if}
	</tbody>
</Table>
